import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e6474e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_task" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flexBetween" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_4 = { class: "normal" }
const _hoisted_5 = {
  class: "flexEnd",
  style: {"padding":"20px"}
}
const _hoisted_6 = { class: "my-header" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "新建任务", -1))
const _hoisted_8 = { class: "qp" }
const _hoisted_9 = { class: "my-header" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "任务详情", -1))

import { useRouter,useRoute } from 'vue-router';
	import { onMounted,ref,nextTick,computed } from 'vue';
	import { requestProjectStepStatusList,requestTaskInfoById } from '@/api/xmApi';
	import AddTask from '@/components/AddTask.vue';
	import { ElMessage } from 'element-plus';
	import TaskDetails from '@/components/TaskDetails.vue'
	
export default /*#__PURE__*/_defineComponent({
  name: 'projectstepstatuslist',
  setup(__props) {

	const router = useRouter()
	const route = useRoute()
	const list = ref([])
	const loading = ref<boolean>(false)
	const addShowTask = ref<boolean>(false)//添加任务
	const addTask = ref<boolean>(false)
	const taskDetails = ref(false)//控制右侧弹窗
	const taskDetailsShow = ref(false)//控制右侧弹窗
	const form = ref({})
	const taskid = ref(route.params.taskid)
	const yuqi =ref(route.params.yuqi);
	const pageIndex = ref<number>(1)
	const pageSize = ref<number>(10)
	const pages = ref({
		totalCount:0
	})
	const search = ref({
		status:0
	})
	const getStatus = computed(()=>{
		return function(status:number,plandate:string){
			let a = {
				1:"进行中",
				2:"关闭",
				3:"待审核",
				4:"完成"
			}
			if(plandate<GetDate()&&status==1){
				return "逾期";
			}else{
				return a[status];
			}
		}
	})
	const getType = computed(()=>{
		return function(status:number,plandate:string){
			let b = {
				1:"primary",
				2:"danger",
				3:"warning",
				4:"success"
			}
			if(plandate<GetDate()&&status==1){
				return "danger";
			}else{
				return b[status];
			}
		}
	})
	const GetDate =()=>{
		var today = new Date();
		var year = today.getFullYear();
		var month = today.getMonth() + 1; // 月份是从0开始的，所以要加1
		var day = today.getDate();
		if(month<=9){
			month="0"+month
		}
		if(day<=9){
			day="0"+day
		}
 		return year+"-"+month+"-"+day;
	}
	const cancelDetails = () => {
		taskDetails.value = false
		getTaskList()
	}
	const cancelTask = (val:any) =>{
		addShowTask.value = false
		if(val){
			getTaskList()
		}
	}
	const searchList = () =>{
		pageIndex.value = 1
		getTaskList();
	}
	const details = (row:any) => {
		if(row==0){
			ElMessage({
					message: "未创建对应任务（先设置计划完成时间后选择负责人）",
					type: 'error',
					duration: 1500
				});
		}else{
			requestTaskInfoById({
				taskid:row
			}).then((res:any)=>{
				form.value =res.datalist
				taskDetailsShow.value = false
				nextTick(()=>{
					taskDetailsShow.value = true
				})
				taskDetails.value = true
			})
		}
		
	}
	//刷新列表
	const taskListsx = () => {
		getTaskList()
		taskDetails.value = false
	}
	//新建任务
	const createTask = () => {
		tasksx()
		addShowTask.value = true
	}
	const tasksx = () => {
		addTask.value = false
		nextTick(()=>{
			addTask.value = true
		})
	}
	onMounted(()=>{
		getTaskList();
	})
	const getTaskList = () => {
		loading.value = true
		requestProjectStepStatusList({
			pageIndex:pageIndex.value,
			pageSize:pageSize.value,
			projectid:taskid.value,
			status:search.value.status,
			yuqi:yuqi.value
		}).then((res:any)=>{
			for(var i=0;i<res.data.length;i++){
				if(res.data[i].cell.operatorreadtime==""){
					res.data[i].cell.operatorreadtime1="未读"
				}else{
					res.data[i].cell.operatorreadtime1="已读"
				}
			}
			list.value = res.data
			pages.value.totalCount = res.totalCount
			loading.value = false
		})
	}
	const handleSizeChange = (val: number) =>{
		pageSize.value = val
		getTaskList();
	}
	const handleCurrentChange = (val: number) =>{
		pageIndex.value = val
		getTaskList();
	}
	const back = () =>{
		router.go(-1)
	}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: list.value,
      "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          width: "70",
          label: "序号",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          label: "项目名称",
          width: "150"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_4, "[" + _toDisplayString(scope.row.cell.code) + "]" + _toDisplayString(scope.row.cell.projectname), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.startdate",
          label: "开始时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.enddate",
          label: "结束时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.p1date",
          label: "计划投产时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.s1date",
          label: "实际投产时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          label: "状态",
          width: "90"
        }, {
          default: _withCtx((scope) => [
            (scope.row.cell.taskid1!=0)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: _unref(getType)(scope.row.cell.status1,scope.row.cell.p1date),
                  onClick: ($event: any) => (details(scope.row.cell.taskid1)),
                  style: {"cursor":"pointer"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getStatus)(scope.row.cell.status1,scope.row.cell.p1date)), 1)
                  ]),
                  _: 2
                }, 1032, ["type", "onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.p2date",
          label: "板料车间计划完工时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.s2date",
          label: "板料车间实际完工时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          label: "状态",
          width: "90"
        }, {
          default: _withCtx((scope) => [
            (scope.row.cell.taskid2!=0)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: _unref(getType)(scope.row.cell.status2,scope.row.cell.p2date),
                  onClick: ($event: any) => (details(scope.row.cell.taskid2)),
                  style: {"cursor":"pointer"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getStatus)(scope.row.cell.status2,scope.row.cell.p2date)), 1)
                  ]),
                  _: 2
                }, 1032, ["type", "onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.p3date",
          label: "零件底漆车间计划完工时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.s3date",
          label: "零件底漆车间实际完工时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          label: "状态",
          width: "90"
        }, {
          default: _withCtx((scope) => [
            (scope.row.cell.taskid3!=0)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: _unref(getType)(scope.row.cell.status3,scope.row.cell.p3date),
                  onClick: ($event: any) => (details(scope.row.cell.taskid3)),
                  style: {"cursor":"pointer"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getStatus)(scope.row.cell.status3,scope.row.cell.p3date)), 1)
                  ]),
                  _: 2
                }, 1032, ["type", "onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.p4date",
          label: "组装车间计划完工时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.s4date",
          label: "组装车间实际完工时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          label: "状态",
          width: "90"
        }, {
          default: _withCtx((scope) => [
            (scope.row.cell.taskid4!=0)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: _unref(getType)(scope.row.cell.status4,scope.row.cell.p4date),
                  onClick: ($event: any) => (details(scope.row.cell.taskid4)),
                  style: {"cursor":"pointer"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getStatus)(scope.row.cell.status4,scope.row.cell.p4date)), 1)
                  ]),
                  _: 2
                }, 1032, ["type", "onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.p5date",
          label: "油漆车间计划完工时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.s5date",
          label: "油漆车间实际完工时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          label: "状态",
          width: "90"
        }, {
          default: _withCtx((scope) => [
            (scope.row.cell.taskid5!=0)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: _unref(getType)(scope.row.cell.status5,scope.row.cell.p5date),
                  onClick: ($event: any) => (details(scope.row.cell.taskid5)),
                  style: {"cursor":"pointer"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getStatus)(scope.row.cell.status5,scope.row.cell.p5date)), 1)
                  ]),
                  _: 2
                }, 1032, ["type", "onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.p6date",
          label: "安包完成计划发货时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.s6date",
          label: "安包实际完工时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          label: "状态",
          width: "90"
        }, {
          default: _withCtx((scope) => [
            (scope.row.cell.taskid6!=0)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: _unref(getType)(scope.row.cell.status6,scope.row.cell.p6date),
                  onClick: ($event: any) => (details(scope.row.cell.taskid6)),
                  style: {"cursor":"pointer"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getStatus)(scope.row.cell.status6,scope.row.cell.p6date)), 1)
                  ]),
                  _: 2
                }, 1032, ["type", "onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        currentPage: pageIndex.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((pageIndex).value = $event)),
        "page-sizes": [10, 20, 30],
        "page-size": pageSize.value,
        "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => ((pageSize).value = $event)),
        layout: "total, sizes, prev, pager, next, jumper",
        total: pages.value.totalCount
      }, null, 8, ["currentPage", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      top: "5vh",
      modelValue: addShowTask.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((addShowTask).value = $event)),
      "show-close": false,
      "close-on-click-modal": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (addShowTask.value=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (addTask.value)
          ? (_openBlock(), _createBlock(AddTask, {
              key: 0,
              id: taskid.value,
              onCancelTask: cancelTask
            }, null, 8, ["id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_el_dialog, {
        modelValue: taskDetails.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((taskDetails).value = $event)),
        "show-close": false,
        fullscreen: ""
      }, {
        header: _withCtx(({ close, titleId, titleClass }) => [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_el_icon, {
              class: "delicon",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (cancelDetails()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Close)
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          (taskDetailsShow.value)
            ? (_openBlock(), _createBlock(TaskDetails, {
                key: 0,
                form: form.value,
                onTaskListsx: taskListsx
              }, null, 8, ["form"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})